export const ACCOUNT_GET_PORTFOLIO_START = 'ACCOUNT_GET_PORTFOLIO_START';
export const ACCOUNT_GET_PORTFOLIO_SUCCESS = 'ACCOUNT_GET_PORTFOLIO_SUCCESS';
export const ACCOUNT_GET_PORTFOLIO_FAILURE = 'ACCOUNT_GET_PORTFOLIO_FAILURE';

export const ACCOUNT_GET_TRADING_TOKEN_START = 'ACCOUNT_GET_TRADING_TOKEN_START';
export const ACCOUNT_GET_TRADING_TOKEN_SUCCESS = 'ACCOUNT_GET_TRADING_TOKEN_SUCCESS';
export const ACCOUNT_GET_TRADING_TOKEN_FAILURE = 'ACCOUNT_GET_TRADING_TOKEN_FAILURE';

export const GET_DEPOSIT_PARAMS_START = 'GET_DEPOSIT_PARAMS_START';
export const GET_DEPOSIT_PARAMS_SUCCESS = 'GET_DEPOSIT_PARAMS_SUCCESS';
export const GET_DEPOSIT_PARAMS_FAILURE = 'GET_DEPOSIT_PARAMS_FAILURE';

export const GET_DEPOSIT_AVAILABLE_METHODS_START = 'GET_DEPOSIT_AVAILABLE_METHODS_START';
export const GET_DEPOSIT_AVAILABLE_METHODS_SUCCESS = 'GET_DEPOSIT_AVAILABLE_METHODS_SUCCESS';
export const GET_DEPOSIT_AVAILABLE_METHODS_FAILURE = 'GET_DEPOSIT_AVAILABLE_METHODS_FAILURE';

export const DEPOSIT_CREATE_WEB_START = 'DEPOSIT_CREATE_WEB_START';
export const DEPOSIT_CREATE_MOBILE_START = 'DEPOSIT_CREATE_MOBILE_START';
export const DEPOSIT_CREATE_SUCCESS = 'DEPOSIT_CREATE_SUCCESS';
export const DEPOSIT_CREATE_FAILURE = 'DEPOSIT_CREATE_FAILURE';
export const DEPOSIT_CREATE_COMPLETE = 'DEPOSIT_CREATE_COMPLETE';

export const GET_DEPOSIT_SURVEY_START = 'GET_DEPOSIT_SURVEY_START';
export const GET_DEPOSIT_SURVEY_SUCCESS = 'GET_DEPOSIT_SURVEY_SUCCESS';
export const GET_DEPOSIT_SURVEY_FAILURE = 'GET_DEPOSIT_SURVEY_FAILURE';

export const SET_IS_CHECK_DEPOSIT_SURVEY = 'SET_IS_CHECK_DEPOSIT_SURVEY';

export const SEND_DEPOSIT_SURVEY_RESULT_START = 'SEND_DEPOSIT_SURVEY_RESULT_START';
export const SEND_DEPOSIT_SURVEY_RESULT_SUCCESS = 'SEND_DEPOSIT_SURVEY_RESULT_SUCCESS';
export const SEND_DEPOSIT_SURVEY_RESULT_FAILURE = 'SEND_DEPOSIT_SURVEY_RESULT_FAILURE';

export const GET_DEPOSIT_FORM_START = 'GET_DEPOSIT_FORM_START';
export const GET_DEPOSIT_FORM_SUCCESS = 'GET_DEPOSIT_FORM_SUCCESS';
export const GET_DEPOSIT_FORM_FAILURE = 'GET_DEPOSIT_FORM_FAILURE';

export const PAYOUT_TRANSACTIONS_START = 'PAYOUT_TRANSACTIONS_START';
export const PAYOUT_TRANSACTIONS_SUCCESS = 'PAYOUT_TRANSACTIONS_SUCCESS';
export const PAYOUT_TRANSACTIONS_FAILURE = 'PAYOUT_TRANSACTIONS_FAILURE';

export const GET_PAYOUT_PARAMS_START = 'GET_PAYOUT_PARAMS_START';
export const GET_PAYOUT_PARAMS_SUCCESS = 'GET_PAYOUT_PARAMS_SUCCESS';
export const GET_PAYOUT_PARAMS_FAILURE = 'GET_PAYOUT_PARAMS_FAILURE';

export const PAYOUT_GET_AVAILABLE_METHODS_START = 'PAYOUT_GET_AVAILABLE_METHODS_START';
export const PAYOUT_GET_AVAILABLE_METHODS_SUCCESS = 'PAYOUT_GET_AVAILABLE_METHODS_SUCCESS';
export const PAYOUT_GET_AVAILABLE_METHODS_FAILURE = 'PAYOUT_GET_AVAILABLE_METHODS_FAILURE';

export const PAYOUT_GET_FORM_START = 'PAYOUT_GET_FORM_START';
export const PAYOUT_GET_FORM_SUCCESS = 'PAYOUT_GET_FORM_SUCCESS';
export const PAYOUT_GET_FORM_FAILURE = 'PAYOUT_GET_FORM_FAILURE';

export const PAYOUT_CREATE_START = 'PAYOUT_CREATE_START';
export const PAYOUT_CREATE_SUCCESS = 'PAYOUT_CREATE_SUCCESS';
export const PAYOUT_CREATE_FAILURE = 'PAYOUT_CREATE_FAILURE';

export const RESET_ACCOUNT_ERROR = 'RESET_ACCOUNT_ERROR';

export const RESEND_USER_CONFIRM_EMAIL_START = 'RESEND_USER_CONFIRM_EMAIL_START';
export const RESEND_USER_CONFIRM_EMAIL_SUCCESS = 'RESEND_USER_CONFIRM_EMAIL_SUCCESS';
export const RESEND_USER_CONFIRM_EMAIL_FAILURE = 'RESEND_USER_CONFIRM_EMAIL_FAILURE';

export const SET_CONFIRM_EMAIL_REQUEST_TIME = 'SET_CONFIRM_EMAIL_REQUEST_TIME';

export const SET_ACCOUNT_SELECTED_HISTORY_INFO = 'SET_ACCOUNT_SELECTED_HISTORY_INFO';

export const WITHDRAWAL_AMOUNT_FIELD_ERRORS = [
    'error.max_withdraw',
    'error.max_withdraw_per_day',
    'error.max_withdraw_per_month',
    'error.max_withdraw_per_week',
    'error.min_withdraw',
    'error.withdrawal_amount',
]
